//#region Styles
import {
    Container, Content
} from "./styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const CustomButton = ({ 
    text, icon, 
    disabled = false, 
    variant = "primary", 
    size = "default", 
    color, angle = "0",
    width, height,
    error = false, errorText, 
    onClick, onBlur, 
    onFocus, className
}) => {
    const getClassName = () => {
        const classList = [];
        classList.push(variant);
        classList.push(size);
        color && classList.push(color);
        icon && classList.push("icon");
        error && classList.push("error");
        return classList.join(" ");
    }
    return (
        <Container 
            className={className} 
            data-role="button" 
            angle={angle}
            width={width}>
            <Content 
                height={height}
                onClick={onClick} 
                onBlur={onBlur} 
                onFocus={onFocus} 
                className={getClassName()}
                offsetPaddingTopBottom={icon ? "0px" : "2px"}
                disabled={disabled}>
                {icon && <div data-role="icon">{icon}</div>}
                {text && <span>{text}</span>}
            </Content>
            <ErrorMessage 
                error={error} 
                text={errorText}/>
        </Container>
    );
}

export default CustomButton;